import * as Types from '../../../../../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TakePaymentMutationVariables = Types.Exact<{
  input: Types.TakePaymentInput;
}>;


export type TakePaymentMutation = { readonly __typename?: 'Mutation', readonly takePayment?: { readonly __typename?: 'Invoice', readonly _id: string, readonly invoiceStatus: Types.InvoiceStatus, readonly transactions: ReadonlyArray<{ readonly __typename?: 'Transaction', readonly _id?: string | null, readonly type?: Types.TransactionType | null, readonly status?: Types.TransactionStatus | null, readonly timestamp?: string | null, readonly notes?: string | null, readonly actionedBy?: { readonly __typename?: 'InvoiceUser', readonly _id?: string | null, readonly uuid?: string | null, readonly role_id?: string | null, readonly email?: string | null, readonly person?: { readonly __typename?: 'InvoicePersonName', readonly firstname?: string | null, readonly middlename?: string | null, readonly lastname?: string | null } | null } | null, readonly payer?: { readonly __typename?: 'Payer', readonly type: Types.PayerType, readonly name: string } | null, readonly amount?: { readonly __typename?: 'Amount', readonly value: number, readonly currency: Types.BillingCurrency } | null, readonly refund?: { readonly __typename?: 'RefundDetails', readonly paymentMethod: Types.PaymentMethod, readonly authCode?: string | null, readonly timestamp?: string | null, readonly reason: string, readonly amount: { readonly __typename?: 'Amount', readonly value: number, readonly currency: Types.BillingCurrency } } | null, readonly payment?: { readonly __typename?: 'PaymentDetails', readonly paymentMethod: Types.PaymentMethod, readonly authCode?: string | null, readonly amount: { readonly __typename?: 'Amount', readonly value: number, readonly currency: Types.BillingCurrency } } | null }>, readonly payers: ReadonlyArray<{ readonly __typename?: 'Payer', readonly balance: { readonly __typename?: 'Balance', readonly total?: number | null, readonly paid?: number | null, readonly due?: number | null } }>, readonly balance: { readonly __typename?: 'Balance', readonly total?: number | null, readonly paid?: number | null, readonly due?: number | null, readonly currency?: Types.BillingCurrency | null } } | null };


export const TakePaymentDocument = gql`
    mutation takePayment($input: TakePaymentInput!) {
  takePayment(input: $input) {
    _id
    invoiceStatus
    transactions {
      _id
      actionedBy {
        _id
        uuid
        role_id
        email
        person {
          firstname
          middlename
          lastname
        }
      }
      type
      status
      timestamp
      notes
      payer {
        type
        name
      }
      amount {
        value
        currency
      }
      refund {
        paymentMethod
        authCode
        amount {
          value
          currency
        }
        timestamp
        reason
      }
      payment {
        paymentMethod
        authCode
        amount {
          value
          currency
        }
      }
    }
    payers {
      balance {
        total
        paid
        due
      }
    }
    balance {
      total
      paid
      due
      currency
    }
  }
}
    `;
export type TakePaymentMutationFn = Apollo.MutationFunction<TakePaymentMutation, TakePaymentMutationVariables>;

/**
 * __useTakePaymentMutation__
 *
 * To run a mutation, you first call `useTakePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTakePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [takePaymentMutation, { data, loading, error }] = useTakePaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTakePaymentMutation(baseOptions?: Apollo.MutationHookOptions<TakePaymentMutation, TakePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TakePaymentMutation, TakePaymentMutationVariables>(TakePaymentDocument, options);
      }
export type TakePaymentMutationHookResult = ReturnType<typeof useTakePaymentMutation>;
export type TakePaymentMutationResult = Apollo.MutationResult<TakePaymentMutation>;
export type TakePaymentMutationOptions = Apollo.BaseMutationOptions<TakePaymentMutation, TakePaymentMutationVariables>;